import { render, staticRenderFns } from "./TiarcoChemicalMOtherIncomeBreakdownTable.vue?vue&type=template&id=edcb7864"
import script from "./TiarcoChemicalMOtherIncomeBreakdownTable.vue?vue&type=script&lang=ts"
export * from "./TiarcoChemicalMOtherIncomeBreakdownTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports